// import { Link } from 'react-router-dom';
// import '../App.css';
// import CONSTANTS from '../CONSTANTS';
// import i18n from '../i18n';
// import NavLink from './NavLink';

// const ROUTES = CONSTANTS.ROUTES;

// function Navigation() {
//   return (
//     <nav id='main-nav'>
//       <Link to={ROUTES.home.path} className="main-nav-logo">
//         <img src="logo192.png" alt="Fishfarm ELAZ logo" />
//       </Link>
//       <ul>
//         <NavLink to={ROUTES.home.path} isBgBlack>
//           {i18n.t(ROUTES.home.title)}
//         </NavLink>
//         <NavLink to={ROUTES.fish.path}>
//           {i18n.t(ROUTES.fish.title)}
//         </NavLink>
//         <NavLink to={ROUTES.about.path}>
//           {i18n.t(ROUTES.about.title)}
//         </NavLink>
//         <NavLink to={ROUTES.projects.path}>
//           {i18n.t(ROUTES.projects.title)}
//         </NavLink>
//         <NavLink to={ROUTES.gallery.path}>
//           {i18n.t(ROUTES.gallery.title)}
//         </NavLink>
//         <NavLink to={ROUTES.contacts.path}>
//           {i18n.t(ROUTES.contacts.title)}
//         </NavLink>
//       </ul>
//     </nav>
//   );
// }

// export default Navigation;

import { Link } from 'react-router-dom';
import { useState } from 'react';
import '../App.css';
import CONSTANTS from '../CONSTANTS';
import i18n from '../i18n';
import NavLink from './NavLink';

const ROUTES = CONSTANTS.ROUTES;

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav id='main-nav'>
      <Link to={ROUTES.home.path} className="main-nav-logo">
        <img src="logo192.png" alt="Fishfarm ELAZ logo" />
      </Link>
      
      {/* Hamburger button */}
      <button 
        className={`hamburger ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Navigation menu */}
      <ul className={isMenuOpen ? 'mobile-open' : ''}>
        <NavLink to={ROUTES.home.path} isBgBlack onClick={closeMenu}>
          {i18n.t(ROUTES.home.title)}
        </NavLink>
        <NavLink to={ROUTES.fish.path} onClick={closeMenu}>
          {i18n.t(ROUTES.fish.title)}
        </NavLink>
        <NavLink to={ROUTES.about.path} onClick={closeMenu}>
          {i18n.t(ROUTES.about.title)}
        </NavLink>
        <NavLink to={ROUTES.projects.path} onClick={closeMenu}>
          {i18n.t(ROUTES.projects.title)}
        </NavLink>
        <NavLink to={ROUTES.gallery.path} onClick={closeMenu}>
          {i18n.t(ROUTES.gallery.title)}
        </NavLink>
        <NavLink to={ROUTES.contacts.path} onClick={closeMenu}>
          {i18n.t(ROUTES.contacts.title)}
        </NavLink>
      </ul>

      {/* Overlay for mobile */}
      {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
    </nav>
  );
}

export default Navigation;